export default __webpack_public_path__ + "static/media/browser (1).f9d1ecc4.svg";